import { FC } from 'react';
import { IonSelect, IonSelectOption } from '@ionic/react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
    select: {
        width: '100%'
    }
});

export interface IEnumSelectOption {
    value: string;
    label: string;
}

export interface IEnumSelectFieldProps {
    label: string;
    value?: string;
    options: IEnumSelectOption[];
    readOnly?: boolean;
    onChange: (value: string) => void;
    'data-id'?: string;
}

export const EnumSelectField: FC<IEnumSelectFieldProps> = ({ label, value, options, readOnly, onChange, 'data-id': dataId }) => {
    const classes = useStyles();

    return (
        <IonSelect
            className={classes.select}
            label={label}
            labelPlacement="stacked"
            fill="outline"
            interface="popover"
            data-id={dataId}
            disabled={readOnly}
            value={value}
            onIonChange={e => onChange(e.detail.value)}
        >
            {options.map(option => (
                <IonSelectOption key={option.value} value={option.value}>
                    {option.label}
                </IonSelectOption>
            ))}
        </IonSelect>
    );
};
